import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history', // 去掉url中的#

  routes: [
    {
      path: '/',
      name: 'points',
      component: () =>
      import('@/views/index/index.vue'),
      meta: {
        keepAlive: true,
      }
    },
    {
      path: '/home',
      name: 'home',
      component:  () =>
      import ('@/views/index/index.vue')
    },
    {
      path: '/dal',
      name: 'dal',
      component:  () =>
      import ('@/views/dal/dal.vue'),
      meta: {
        keepAlive: true,
      }
    },
    {
      path: '/record',
      name: 'record',
      component:  () =>
      import ('@/views/index/record.vue')
    },
    {
      path: '/painter',
      name: 'paint',
      component:  () =>
      import ('@/views/paint/paintdetail/addpainter.vue')
    },
    {
      path: '/painterlist',
      name: 'paintlist',
      component:  () =>
      import ('@/views/paint/paintdetail/painterlist.vue')
    },
    {
      path: '/choujiang',
      name: 'choujiang',
      component:  () =>
      import ('@/components/gb-choujiang.vue')
    },
    {
      path: '/addresslist',
      name: 'addresslist',
      component:  () =>
      import ('@/views/address/index.vue')
    },
    {
      path: '/addaddress',
      name: 'addaddress',
      component:  () =>
      import ('@/views/address/addaddress.vue')
    },
    {
      path: '/video',
      name: 'video',
      component:  () =>
      import ('@/views/daihuobao/H5video.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js